<template>
    <div class="list">

        <el-form :model="dioForm" label-width="120px">
            <el-row>
                <el-col :span="12" v-for="item in baseMsg" :key="item.key">

                    <el-form-item :label="$t(item.text)">
                        <template v-if="item.key === 'description'">
                            <span v-if="!isEdit">
                                {{ dioForm.description }}
                            </span>

                            <el-input v-else type="textarea" v-model="areaValue" maxlength="250"
                                :autosize="{ minRows: 3, maxRows: 4 }" style="width: 200px" show-word-limit></el-input>
                        </template>

                        <template v-else-if="item.key === 'nickname'">
                            <span v-if="!isEdit">
                                {{ dioForm.nickname }}
                            </span>

                            <el-input v-else type="text" v-model="nickname" style="width: 200px" maxlength="30">
                            </el-input>
                        </template>
                        <template v-else>
                            <span>
                                <span>{{ switchFn(item.key, detailObj[item.key]) }}</span>
                            </span>
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item v-if="isMode">
                <el-button type="primary" @click="saveDecFn">
                    <i class="el-icon-folder-checked button-icon "></i>
                    {{ $t("public.save") }}
                </el-button>
                <el-button type="primary" @click="goBack"><i class="el-icon-refresh-left button-icon"></i>{{ $t("返回") }}
                </el-button>
            </el-form-item>
            <el-form-item v-if="!isMode">
                <el-button type="primary" @click="goBack"><i class="el-icon-edit button-icon"></i>{{ $t('public.edit')
                }}
                </el-button>
            </el-form-item>

        </el-form>

    </div>
</template>

<script>
export default {

    props: ['baseMsg', 'isMode', 'detailObj'],
    data() {
        return {
            dioForm: {},
            isEdit: false,
            nickname: '',
            areaValue: '',
        }
    },
    watch: {
        detailObj(newVal) {
            this.dioForm = { ...newVal }
        },
        isMode(newVal) {
            this.isEdit = newVal;
            this.areaValue = this.detailObj['description']
            this.nickname = this.detailObj['nickname']
            this.dioForm.isHeart = this.detailObj.isHeart
        }
    },
    methods: {
        switchFn(key, value) {
            switch (key) {
                case 'configStatus': {
                    return value === 0 ? $t('device.wait_config') : value === 1 ? $t('device.configured') : $t('device.configured')
                }
                case 'type': {
                    return value === 1 ? $t('deviceType.rt_1') : ''
                }

                case 'alarmOn': {
                    return value === 1 ? $t('public.btn_yes') : $t('public.btn_no')
                }
                case 'createTime': {
                    return this.$timetransition(value)
                }
                case 'stopTime': {
                    return this.$timetransition(value)
                }
                case 'carrierName': {
                    return this.carrierFn(value)
                }
                default:
                    break
            }
            return value
        },
        carrierFn(carrierName) {
            if (!carrierName) return
            let array = carrierName.split(',')
            return array
                .map(item => {
                    let newArray = item.split('-')
                    return newArray[newArray.length - 1]
                })
                .join(',')
        },
        goBack() {
            this.areaValue = this.detailObj['description']
            this.nickname = this.detailObj['nickname']
            this.$emit('update:isMode', !this.isMode)
        },
        saveDecFn() {
            const { id } = this.dioForm;
            this.$emit('saveDecFn', { id, nickname: this.nickname, areaValue: this.areaValue });

        }
    }
}
</script>

<style lang="scss" scoped>
.list {
    flex: 1;
}

::v-deep .button-icon {
    margin: 0;
    color: white;
    font-size: 14px;
    font-weight: 100;
    margin-right: 5px;
}
</style>
